import React from 'react';

// Define the props for the Tooltip component
interface TooltipProps {
    children: React.ReactNode; // The content that the Tooltip will wrap
    text: string; // The text to be displayed inside the Tooltip
    direction?: 'top' | 'right' | 'bottom' | 'left' | 'top-preset'; // The direction in which the Tooltip should appear
    show?: boolean; // Optional flag to control the visibility of the Tooltip
    width?:string;
    contentPositionX?:'end' | 'right' | 'bottom' | 'start' ; // Optional flag to control position of the tooltip content
}

// Tooltip component definition
const Tooltip: React.FC<TooltipProps> = ({ children, text, direction = 'bottom', show,  width='w-auto', contentPositionX='center' }) => {
    return (
        // Container div for the Tooltip
        <div className={`${width} tooltip tooltip-${direction} relative flex items-center justify-${contentPositionX}`}>
            {children} {/* The content wrapped by the Tooltip */}
            {/* The actual Tooltip text */}
            <span className={`tooltiptext ${show ? '' : 'hidden'}`}>
                {/* Arrow pointing to the Tooltip content */}
                <div className={`tooltip-arrow tooltip-arrow-${direction}`}></div>
                {/*{*/}
                {/*    text.split('\n').map((line, index) => (*/}
                {/*        <p key={index} className="text-xs">{line}</p>*/}
                {/*    ))*/}
                {/*}*/}
                {text}
            </span>
        </div>
    );
};

export default Tooltip; // Exporting the Tooltip component
